module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "print-calendars text-dark",
    attrs: {
      "id": "printCalendars"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.loading')))])], 1) : [(_vm.calendars.length < 1) ? _c('h2', {
    staticClass: "explainer-text italic pad-20"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.no_calendars')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.calendars), function(calendar) {
    return _c('div', {
      key: calendar.id,
      staticClass: "d-calendar"
    }, [(_vm.theViewSetting !== 'list') ? _c('h2', {
      staticClass: "text-dark"
    }, [_vm._v(_vm._s(calendar.name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "calculate-hours-wrapper"
    }, [(_vm.isPrintHours) ? _c('CalculateHours', {
      staticClass: "print-calculate-hours",
      attrs: {
        "isShowOptions": false,
        "schoolId": _vm.schoolId,
        "calendarId": calendar.id,
        "date": _vm.date
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "d-calendar__calendar__container d-calendar__calendar__container--print-mode",
      class: [{
        'd-calendar__calendar__container--print-mode--is-list': _vm.theViewSetting === 'list'
      }, {
        'd-calendar__calendar__container--print-mode--is-print-hours': _vm.isPrintHours
      }]
    }, [(_vm.theViewSetting === 'blocks') ? _c('DCalendarPrint', {
      attrs: {
        "isCalendarInPrintMode": true,
        "isShowWeekends": _vm.isShowWeekends,
        "startTime": _vm.startTime,
        "endTime": _vm.endTime,
        "date": _vm.date,
        "events": calendar.events,
        "calendarId": calendar.id,
        "calendarName": calendar.name,
        "firstDayOfWeek": _vm.firstDayOfWeek
      }
    }) : _vm._e(), _vm._v(" "), (_vm.theViewSetting === 'calendar' || _vm.theViewSetting === 'list') ? _c('DCalendar', {
      attrs: {
        "isCalendarInPrintMode": true,
        "isShowWeekends": _vm.isShowWeekends,
        "isHideCalendars": _vm.isHideCalendars,
        "isHideDates": _vm.isHideDates,
        "isCalNoBgColors": _vm.isCalNoBgColors,
        "eventFontSize": _vm.eventFontSize,
        "startTime": _vm.startTime,
        "endTime": _vm.endTime,
        "date": _vm.date,
        "events": calendar.events,
        "calendarId": calendar.id,
        "calendarName": calendar.name,
        "isShowAsList": _vm.theViewSetting === 'list',
        "firstDayOfWeek": _vm.firstDayOfWeek
      }
    }) : _vm._e()], 1)], 1)])
  })], _vm._v(" "), (_vm.isShowPrintButton) ? _c('DModal', {
    staticClass: "modal-print-button",
    class: {
      'modal-print-button--hide': !_vm.isShowPrintButton
    },
    attrs: {
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal__content d-modal__print_button",
    class: {
      'd-modal__print_button--wide': _vm.showDSelect
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [(_vm.showDSelect) ? _c('div', {
    staticClass: "custom-select-calendars"
  }, [_c('label', {
    staticClass: "d-label marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.custom')))]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "appendToBody": true
    },
    on: {
      "updateItems": function($event) {
        return _vm.dSelectCalsUpdated('update', $event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-select-calendars__submit"
  }, [(!_vm.isCalendarsSelected) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.setIsCalendarsSelected
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDSelect || _vm.isCalendarsSelected),
      expression: "!showDSelect || isCalendarsSelected"
    }],
    staticClass: "d-modal__print_button__settings"
  }, [_c('div', {
    staticClass: "d-input-group marg-1-bottom",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('label', {
    staticClass: "d-input marg-05-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('TimeChanger', {
    staticClass: "marg-1-top",
    attrs: {
      "showIcon": true,
      "start": _vm.startTimeDate,
      "end": _vm.endTimeDate
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSetting('isHideDates', !_vm.isHideDates)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.hide_dates')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isHideDates
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSetting('isShowWeekends', !_vm.isShowWeekends)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_weekends')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isShowWeekends
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setViewSetting('list')
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_as_list')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.theViewSetting === 'list'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setViewSetting('blocks')
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_as_blocks')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.theViewSetting === 'blocks'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSetting('isPrintHours', !_vm.isPrintHours)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.show_print_hours')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isPrintHours
    }
  })], 1), _vm._v(" "), (_vm.theViewSetting === 'calendar') ? _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSetting('isCalNoBgColors', !_vm.isCalNoBgColors)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.show_print_without_bg_colors')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isCalNoBgColors
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeSetting('isHideCalendars', !_vm.isHideCalendars)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.hide_calendars')))]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isHideCalendars
    }
  })], 1), _vm._v(" "), (_vm.theViewSetting === 'calendar') ? _c('div', {
    staticClass: "input-group input-group__toggle"
  }, [_c('label', {
    staticClass: "d-label marg-1-right"
  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.event_font_size')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eventFontSize),
      expression: "eventFontSize"
    }],
    attrs: {
      "type": "range",
      "name": "vol",
      "min": "4",
      "max": "16"
    },
    domProps: {
      "value": (_vm.eventFontSize)
    },
    on: {
      "change": function($event) {
        return _vm.changeSetting('eventFontSize', _vm.eventFontSize)
      },
      "__r": function($event) {
        _vm.eventFontSize = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__print_button__submit",
    class: {
      'd-modal__print_button__submit--space': _vm.hasUserPrintSettings
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasUserPrintSettings),
      expression: "hasUserPrintSettings"
    }],
    staticClass: "text-link",
    on: {
      "click": _vm.resetPrintSettings
    }
  }, [_vm._v("Nulstil")]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__print_button__submit--right"
  }, [_c('button', {
    staticClass: "marg-1-right do-bttn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.print_all_calendars.print')))])])])])])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c5bb548!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintCalendars/PrintCalendars.vue
// module id = 1637
// module chunks = 1